import { render } from "./ReadOnly.vue?vue&type=template&id=7672c896"
import script from "./ReadOnly.vue?vue&type=script&lang=js"
export * from "./ReadOnly.vue?vue&type=script&lang=js"
script.render = render

export default script